import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, ButtonToolbar, Container } from "reactstrap";
import Button from "@material-ui/core/Button";
import { Tooltip } from "@material-ui/core";
import PropertyCard from "./../reportviews/propertycompreport/components/PropertyCard";
import { ButtonGroup } from "@material-ui/core";
import { calculateAverages, getDerived, formatPropertyData, formatPropertyDataSold } from "./utils";
import InfoIcon from "mdi-react/InformationIcon";
import Slider from "react-slick";
import ArrowRightIcon from 'mdi-react/ArrowRightDropCircleIcon';
import ArrowLeftIcon from 'mdi-react/ArrowLeftDropCircleIcon';
import BuildingSearchAppBar from '../../../../shared/components/building_filters/UnitsSearchAppBar';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  _isHouse,
  _formatPrice,
  _formatNumber,
  setLocalStorage,
  getLocalStorage,
  syncURLFilters,
  _objectEqual
} from "../../../../shared/helpers/utils";
import { 
	_unitFilters,
	_buildingStageFilter,
	_unitStageFilter
} from "../../../../shared/helpers/filters";
import { _axiosCall } from '../../../../shared/helpers/apicalls';
let lsPre = "COMP1_";
const subFilterKey = 'subFilters';
const unitStagesKey = 'unitStages';
const buildingStagesKey = 'buildingStages';
const defaultSubFilter = {current_status : ["available"], property_type : ["residential"]};
const defaultUnitStage = ["all"];
const defaultStage = ["all"];


const NestedModal = (props) => {
  const { isOpen, toggle, reportData, nestedModalData, setReportData, setSubmit, setAiResponse, setFetchAi, openDetailModal, searchTags } = props;
  const [pendingSelections, setPendingSelections] = useState([]);
  const [availableComps, setAvailableComps] = useState([]);
  const [compSource, setCompSource] = useState("activeComps");
  const [errorMessage, setErrorMessage] = useState("");
  const [maxSelectable, setMaxSelectable] = useState(3);
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [subFilters, setSubFilters] = useState(defaultSubFilter);
  const [subFilter, setSubFilter] = useState(null);
  const [buildingStages, setBuildingStages] = useState(defaultStage);
  const [unitStages, setUnitStages] = useState(defaultUnitStage);
  const [start, setStart] = useState(0);
  const handleSearch = async (name, value) => {
	setSearchText(value);
  
	try {
	  const response = await _axiosCall({
		url: `${process.env.API_ROOT}/query/we3-properties`,
		method: 'post',
		query: {
		  q: `building_name:*${value}* OR display_full_street_address:*${value}*`,
		  fq: ['deleted:false'],
		  fl: [
			'id',
			'display_full_street_address',
			'neighborhood',
			'borough',
			'building_name'
		  ],
		  rows: 25,
		  wt: 'json'
		}
	  });
  
	  const results = response && response.docs || [];
	  setSearchResults(results);
	  setFilteredResults(results); // default to all results if no subfilter yet
  
  
	} catch (err) {
	  console.error('Search failed:', err);
	  setSearchResults([]);
	  setFilteredResults([]);
	}
  };
  
  const handleSubFilters = (theSubFilters) => {
	const subF = Object.assign({}, subFilters, theSubFilters);
  
	setSubFilters(subF);
	setStart(0)
  };
  
  const handleSubFilter = (search_key, search_val) => {
  
	  const subF = Object.assign({}, subFilters, {
			  [search_key]: search_val
		  });
	  
	  setSubFilters(subF);
	  setStart(0);
  }
  
  
  const resetSubFilter = () => {
	
	setSubFilters(defaultSubFilter);
	setBuildingStages(defaultStage);
	setUnitStages(unitStages);
	setStart(0)
  };
  
  const setBuildingStage = (stage) => {
  
	  let newStages = buildingStages.slice();
	  const index = newStages.indexOf(stage);		
	  const indexAll = newStages.indexOf('all');
	  
	  
	  if(index>=0){
		  
		  if(stage === "all"){
			  newStages = this.defaultStage
		  }else{
			  newStages.splice(index, 1);
		  }
	  }else{
		  if(stage === "all"){
			  newStages = ["all"]
		  }else{
			  if(indexAll>=0){
				  newStages.splice(indexAll, 1);
			  }
			  newStages.push(stage)
		  }
		  
	  }
	  
	  if(newStages.length === 0 ) newStages = ['all'];
	  
	  setBuildingStages(newStages);
	  setStart(0);
	  setLocalStorage(lsPre, buildingStagesKey, JSON.stringify(newStages));
  }
  
  const resetActive = () => {
	  
	  
	  
	  let isDefault = true;
	  isDefault = searchTags.length===0 &&
		_objectEqual(defaultSubFilter, subFilters) &&
		_objectEqual(defaultUnitStage, unitStages) &&
		_objectEqual(defaultStage, buildingStages);
	  
		
	  return !isDefault;
	  
  }
  
  const settings = {
		dots: false,
		infinite: false,
		speed: 500,
		autoplay: false,
		swipeToSlide: true,
		variableWidth: true, // ← key option
		prevArrow: <ArrowLeftIcon size={50} fill="#000" />,
		nextArrow: <ArrowRightIcon  size={50} fill="#000" />,
		// responsive: [
		//   { breakpoint: 768, settings: { slidesToShow: 1 } },
		//   { breakpoint: 992, settings: { slidesToShow: 2 } },
		//   { breakpoint: 1200, settings: { slidesToShow: 3 } },
		//   { breakpoint: 1536, settings: { slidesToShow: 3 } },
		//   { breakpoint: 100000, settings: { slidesToShow: 4 } },
		// ],
	};
  useEffect(function() {
	if (reportData && reportData.derivedData && nestedModalData) {
	  var activeComps = reportData.derivedData.activeComps;
	  var soldComps = reportData.derivedData.soldComps;
	  var compResponse = reportData.compResponse;

	  var isActive = false;
	  for (var i = 0; i < activeComps.length; i++) {
		if (activeComps[i].id === nestedModalData.compKey) {
		  isActive = true;
		  break;
		}
	  }
	  var source = isActive ? "activeComps" : "soldComps";
	  setCompSource(source);

	  var pool = isActive ? compResponse.comps.active : compResponse.comps.sold;
	  var formatted = [];
	  for (var j = 0; j < pool.length; j++) {
		formatted.push(source === "activeComps" ? formatPropertyData(pool[j]) : formatPropertyDataSold(pool[j]));
	  }
	  setAvailableComps(formatted);

	  var usedIds = (isActive ? activeComps : soldComps).map(function(c) { return c.id; });
	  var initialSelections = nestedModalData.compKey
		? usedIds.filter(function(id) { return id !== nestedModalData.compKey; })
		: usedIds;
	  setPendingSelections(initialSelections);

	  const maxAvail = nestedModalData.compKey ? formatted.length - 1 : formatted.length;
	  setMaxSelectable(Math.min(3, maxAvail));
	}
  }, [reportData, nestedModalData]);

  if (!isOpen || !reportData || !reportData.derivedData) return null;

  const handleSelectComp = function(compId) {
	setFetchAi(false);
	setPendingSelections(function(prev) {
	  if (prev.indexOf(compId) !== -1) {
		return prev.filter(function(id) { return id !== compId; });
	  } else {
		if (prev.length < maxSelectable) {
		  return prev.concat(compId);
		} else {
		  setErrorMessage("Maximum number of comps already selected, you must unselect a comp first.");
		  setTimeout(function() {
			setErrorMessage("");
		  }, 3000);
		  return prev;
		}
	  }
	});
  };

  const handleConfirm = function() {
	if (pendingSelections.length !== maxSelectable) return;

	var poolActive = reportData.compResponse.comps.active || [];
	var poolSold = reportData.compResponse.comps.sold || [];

	var foundComps = [];
	for (var i = 0; i < pendingSelections.length; i++) {
	  var found = null;
	  for (var j = 0; j < poolActive.length; j++) {
		if (poolActive[j].id === pendingSelections[i]) {
		  found = poolActive[j];
		  break;
		}
	  }
	  if (!found) {
		for (var k = 0; k < poolSold.length; k++) {
		  if (poolSold[k].id === pendingSelections[i]) {
			found = poolSold[k];
			break;
		  }
		}
	  }
	  if (found) {
		foundComps.push(found);
	  }
	}

	let theReportData = Object.assign({}, reportData);
	let originalComps = compSource === "activeComps"
	  ? theReportData.derivedData.activeComps
	  : theReportData.derivedData.soldComps;

	let replacedIndex = originalComps.findIndex(function(comp) {
	  return comp.id === nestedModalData.compKey;
	});

	if (replacedIndex !== -1 && foundComps.length === maxSelectable) {
	  let newComps = [...foundComps];
	  let replacedComp = newComps.pop();
	  newComps.splice(replacedIndex, 0, replacedComp);

	  if (compSource === "activeComps") {
		theReportData.derivedData.activeComps = newComps;
	  } else {
		theReportData.derivedData.soldComps = newComps;
	  }
	}

	const derivedData = getDerived(
	  theReportData,
	  theReportData.derivedData.activeComps,
	  theReportData.derivedData.soldComps
	);
	theReportData.derivedData = derivedData;

	setReportData(theReportData);
	setAiResponse(null);
	setFetchAi(true);
	toggle();
  };

  return (
	<Modal isOpen={isOpen} toggle={toggle} size="lg" className="full_width_modal modal-body-left">
	  <ModalHeader toggle={toggle}>
		<h4 className="contact__title" style={{ textAlign: "left" }}>
		  Select Comparable Properties
		</h4>
		<p style={{ textTransform: "initial", textAlign: "left", marginBottom: "10px" }}>
		  Choose {maxSelectable} propert{maxSelectable === 1 ? "y" : "ies"} that are most comparable to the subject property.
		</p>
	  </ModalHeader>
	  <ModalBody>
	    {/* <div>
	  		<BuildingSearchAppBar
				handleSearch={handleSearch}
				searchText={searchText}
				setSubFilters={handleSubFilters}
				resetSubFilter={resetSubFilter}
				subFilters={subFilters}
				setSubFilter={handleSubFilter}
				_filters={_unitFilters}      // pass available filters like borough/neighborhood if needed
				placeHolder="Search by Address, Building, or Neighborhood"
				numToShow={7}
				buildingStages={buildingStages}
				setBuildingStage={setBuildingStage}
				resetActive={resetActive()}
				buildingAttributes={[]}
		  	/>
	    </div> */}
		<Container className="dashboard">
		  {errorMessage && (
			<div style={{
			  backgroundColor: "#FFF",
			  border:"1px solid #780F9E",
			  color: "#780F9E",
			  padding: "10px 20px",
			  borderRadius: "4px",
			  marginBottom: "0px",
			  fontSize: "14px",
			  textAlign:"left"
			}}>
			  {errorMessage}
			</div>
		  )}
		  <p style={{ fontSize: "18px", marginBottom: "15px", textAlign: "left", fontWeight:600, display:"flex", alignItems:"center", gap:"5px" }}>
		  	<InfoIcon color={"#780F9E"} /> 
			{pendingSelections.length < maxSelectable
				? `Please select ${maxSelectable} comp${maxSelectable === 1 ? '' : 's'} to continue. `
				: `${maxSelectable} comp${maxSelectable === 1 ? '' : 's'} selected. Select one to replace or update report. `}
			   Showing {availableComps.length} similar propert{availableComps.length === 1 ? "y" : "ies"}
			  {availableComps.length > 3 ? " — scroll right to view all." : "."}
		  </p>
		  <div className="all-comps-container">
			<div className="property-comparison-container comp-changer">
			  <PropertyCard
				property={compSource === "activeComps" ? formatPropertyData(reportData.derivedData.subjectProperty, true) : formatPropertyDataSold(reportData.derivedData.subjectProperty, true)}
				index={0}
				isSubject={true}
				showSelectIcon={false}
				compSource={compSource} 
				openDetailModal={openDetailModal}
				avgDOM={reportData && reportData.derivedData && reportData.derivedData.avgDOM ? _formatNumber(reportData.derivedData.avgDOM) : null}
			  />
			  <Slider {...settings} className="">
			  {availableComps.map(function(property, idx) {
				var isSelected = pendingSelections.indexOf(property.id) !== -1;
				var buttonText = isSelected ? "Remove" : "Select";
				var disableSelect = !isSelected && pendingSelections.length >= maxSelectable;

				return (
				  <PropertyCard
					key={property.id}
					property={property}
					index={idx + 1}
					isSubject={false}
					isSelected={isSelected}
					buttonText={buttonText}
					disableSelect={disableSelect}
					onClick={function(e) {
					  e.preventDefault();
					  e.stopPropagation();
					  handleSelectComp(property.id);
					}}
					showSelectIcon={true}
					openDetailModal={openDetailModal}
					compSource={compSource} //
					avgDOM={reportData && reportData.derivedData && reportData.derivedData.avgDOM ? _formatNumber(reportData.derivedData.avgDOM) : null}
				  />
				);
			  })}
			  </Slider>
			</div>
		  </div>
		</Container>
	  </ModalBody>
	  <ModalFooter>
		<ButtonToolbar className="modal__footer mb-3">
		  <Tooltip title="Cancel">
			<Button onClick={toggle} variant="outlined" className="mr-2">
			  Cancel
			</Button>
		  </Tooltip>
		  <Tooltip title="Reset Selections">
			<Button
			  onClick={function() { setPendingSelections([]); }}
			  variant="outlined"
			  className="mr-2"
			  disabled={pendingSelections.length === 0}
			>
			  Remove All Comps
			</Button>
		  </Tooltip>
		  <Tooltip title="Confirm Selection">
			<Button
			  onClick={handleConfirm}
			  variant="contained"
			  color="primary"
			  disabled={pendingSelections.length !== maxSelectable}
			>
			  Update Report ({pendingSelections.length}/{maxSelectable} Selected)
			</Button>
		  </Tooltip>
		</ButtonToolbar>
	  </ModalFooter>
	</Modal>
  );
};


const mapStateToProps = (state) => ({
  user: state.user,
  searchTags: Array.isArray(state.search.searchTags)
	? state.search.searchTags.slice()
	: [],
});

export default withRouter(connect(mapStateToProps)(NestedModal));
